module.exports = __webpack_public_path__ + "src/assets/images/product-icons/icon-plumbing.png?904f3a66d2dad29c65f0ce6225e9e44b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-icons/icon-plumbing.png
// module id = 1039
// module chunks = 1